import React, {FC} from 'react';

import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {UserThemeConsumer} from '../../../../libs/shared/ui/src/theme/userThemeConsumer';

export const WorkspaceItemRefinedResultsIndicator: FC = (props) => (
  <UserThemeConsumer>
    {(theme) => <Icon name="filtersFilledSmall" color={theme.refinedP2ResultsIndicator} {...props} />}
  </UserThemeConsumer>
);
